/**
 * Central API base URL.
 * In local dev (localhost), use empty string so CRA proxy forwards /api/* to Flask.
 * In production (Cloudflare Pages), default to the Render backend URL.
 */
const isLocal = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const API_BASE = process.env.REACT_APP_API_URL || 
  (isLocal ? '' : 'https://personal-finance-ygx6.onrender.com');

export default API_BASE;
